import { Component, Input, forwardRef, Optional, Host, SkipSelf, OnInit, EventEmitter, Output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, ControlContainer, AbstractControl, FormsModule } from '@angular/forms';
import { NgIf, NgClass, NgFor } from '@angular/common';
import { NgxIntlTelInputModule } from 'untold-ngx-intl-tel-input';


@Component({
    selector: 'app-dropdown-input-v2',
    templateUrl: './dropdown-input-v2.component.html',
    styleUrls: ['./dropdown-input-v2.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => DropdownInputV2Component),
            multi: true,
        },
    ],
    imports: [NgIf, FormsModule, NgxIntlTelInputModule, NgClass, NgFor],
    standalone: true
})
export class DropdownInputV2Component implements ControlValueAccessor, OnInit {
  @Input() label;
  @Input() requiredMark = false;
  @Input() options;
  @Input() textOption;
  @Input() disableDefault = true;
  @Input() initValue = false;
  @Input() tabId = 0;
  @Input() placeholder;
  @Input() invalidMsg = 'Invalid field';
  @Input() submitAttempted = false;
  @Input() formControlName: string;
  @Input() inputClasses = '';
  @Output() change = new EventEmitter;

  public disabled = false;
  public model;
  public currentControl: AbstractControl;
  public _value = '';
  public propagateChange: any = () => {};

  constructor(
    @Optional()
    @Host()
    @SkipSelf()
    private controlContainer: ControlContainer
  ) {}

  ngOnInit() {
    if (this.controlContainer) {
      this.currentControl = this.controlContainer.control.get(this.formControlName);
      this.model = this.currentControl.value;
    }

    if (this.initValue) {
      this.model = this.initValue;
    }
  }

  writeValue(value: any) {
    if (value) {
      this._value = value;
      this.model = value;
    } else {
      this._value = null;
      this.model = null;
    }
  }

  registerOnChange(fn) {
    this.propagateChange = fn;
  }
  registerOnTouched(fn: () => void): void {}

  onChange(event) {
    console.log('onChange:', event)
    this.propagateChange(event.target.value);
  }

  setValue(value) {
    this.model = value;
    this.propagateChange(value);
    this.change.emit(value);
  }

  hasValidationError() {
    return !this.currentControl.valid && this.submitAttempted;
  }

  setDisabledState(isDisabled) {
    this.disabled = isDisabled;
  }
}
